"use client";

import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useCategories } from "@/modules/products/hooks/useCategories";

export const CategoryPills = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { data } = useCategories();

  const categories = data?.response?.product_categories ?? [];
  const activeCategory = searchParams.get("category_id");

  const selectCategory = (categoryId: string | null) => {
    const params = new URLSearchParams(searchParams.toString());
    if (categoryId) {
      params.set("category_id", categoryId);
    } else {
      params.delete("category_id");
    }
    params.delete("page"); // reset pagination when the filter changes
    router.replace(`${pathname}?${params.toString()}`, { scroll: false });
  };

  const pillClass = (active: boolean) =>
    `whitespace-nowrap rounded-full px-5 py-2 text-sm font-medium transition-colors ${
      active
        ? "bg-green-main text-white shadow-[0_2px_8px_rgba(5,153,58,0.3)]"
        : "border-green-main text-green-main hover:bg-cream border bg-white"
    }`;

  return (
    <div className="bg-cream sticky top-20 z-30 mb-6 py-3">
      <div className="flex gap-3 overflow-x-auto pb-1">
        <button
          type="button"
          onClick={() => selectCategory(null)}
          aria-pressed={!activeCategory}
          className={pillClass(!activeCategory)}
        >
          Todos
        </button>
        {categories.map((category) => (
          <button
            key={category.id}
            type="button"
            onClick={() => selectCategory(category.id)}
            aria-pressed={activeCategory === category.id}
            className={pillClass(activeCategory === category.id)}
          >
            {category.name}
          </button>
        ))}
      </div>
    </div>
  );
};
